import React, { Component } from 'react';
import './styles.css';

export default class Documents extends Component {
  render() {
    return (
      <div className="dashboard">
        <h1>Documents Page</h1>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Documents/Documents.js